import styled, { createGlobalStyle, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`

const c = {
  bg: '#0a0c0f', bg2: '#111318', bg3: '#181c23', bg4: '#1e2330',
  bdr: '#1f2430', bdr2: '#2a3040',
  acc: '#00e5a0', acc2: '#00b87a',
  adim: 'rgba(0,229,160,.08)', adim2: 'rgba(0,229,160,.18)',
  txt: '#e8ecf0', txt2: '#8a95a3', txt3: '#5a6370',
  warn: '#f59e0b', danger: '#ef4444', info: '#3b82f6',
  mono: "'Space Mono',monospace", sans: "'DM Sans',sans-serif",
}

export const GlobalBoxesStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
`

export const PageWrap = styled.div`
  background:${c.bg}; color:${c.txt}; font-family:${c.sans};
  height:100vh; display:flex; flex-direction:column; overflow:hidden;
`

export const Topbar = styled.div`
  background:${c.bg2}; border-bottom:1px solid ${c.bdr};
  padding:10px 16px; height:48px;
  display:flex; align-items:center; gap:14px; flex-shrink:0;
  h2 { font-size:13px; font-weight:600; color:${c.txt}; }
  .crumb { font-size:11px; color:${c.txt3}; }
`

export const Body = styled.div`flex:1; display:flex; flex-direction:column; min-height:0;`

export const Toolbar = styled.div`
  display:flex; align-items:center; gap:12px; padding:14px 20px;
  background:${c.bg2}; border-bottom:1px solid ${c.bdr}; flex-shrink:0;
`
export const Search = styled.input`
  flex:1; max-width:380px; background:${c.bg3};
  border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:9px 12px; font-size:12px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const Stats = styled.div`
  display:flex; gap:14px; align-items:center; font-size:11px; color:${c.txt3};
  strong {
    color:${c.acc}; font-family:${c.mono}; font-size:14px;
    font-weight:700; margin-right:4px;
  }
`
export const NewBtn = styled.button`
  background:${c.acc}; border:none; color:#000;
  padding:9px 16px; border-radius:8px; cursor:pointer;
  font-size:12px; font-weight:700; font-family:${c.sans};
  transition:.15s; margin-left:auto;
  &:hover { filter:brightness(1.1); }
  &:disabled { opacity:.5; cursor:not-allowed; }
`
export const RefreshBtn = styled.button`
  background:${c.bg3}; border:1px solid ${c.bdr2}; color:${c.txt2};
  padding:8px 12px; border-radius:7px; font-size:11px; cursor:pointer;
  transition:.15s; font-family:${c.sans};
  &:hover { border-color:${c.acc}; color:${c.acc}; }
  &:disabled { opacity:.5; cursor:not-allowed; }
`

// ─── Listagem em cards ─────────────────────────────────────────────────────
export const ListWrap = styled.div`
  flex:1; overflow-y:auto; padding:18px 20px 40px;
  display:grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap:12px; align-content:start;
  &::-webkit-scrollbar { width:6px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`
export const BCard = styled.div`
  background:${c.bg2}; border:1px solid ${({ $hasOrders }) => $hasOrders ? c.acc2 : c.bdr};
  border-left:3px solid ${({ $hasOrders, $inactive }) =>
    $inactive ? c.txt3 : $hasOrders ? c.acc : c.bdr2};
  border-radius:10px; overflow:hidden;
  animation:${fadeIn} .2s ease;
  opacity:${({ $inactive }) => $inactive ? 0.6 : 1};
  transition:.15s;
  &:hover { transform:translateY(-1px); box-shadow:0 4px 16px rgba(0,0,0,.3); }
`
export const BHead = styled.div`
  display:flex; align-items:center; gap:10px; padding:14px 16px 10px;
`
export const BSeq = styled.div`
  font-family:${c.mono}; font-size:11px; color:${c.txt3};
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:6px;
  padding:3px 8px; font-weight:700;
`
export const BName = styled.div`
  flex:1; font-size:14px; font-weight:600; color:${c.txt};
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
`
export const StatusDot = styled.span`
  width:8px; height:8px; border-radius:50%;
  background:${({ $on }) => $on ? c.acc : c.txt3};
  flex-shrink:0;
  ${({ $on }) => $on && `box-shadow: 0 0 0 3px rgba(0,229,160,.18);`}
`
export const BBarcode = styled.div`
  padding:0 16px 10px;
  font-family:${c.mono}; font-size:11px; color:${c.txt2};
  .lbl { font-size:9px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em; margin-right:6px; }
  .code {
    background:${c.bg3}; padding:2px 7px; border-radius:5px;
    border:1px solid ${c.bdr2};
  }
`
export const BMeta = styled.div`
  padding:10px 16px;
  border-top:1px solid ${c.bdr};
  display:grid; grid-template-columns:1fr 1fr; gap:8px;
`
export const BMetaItem = styled.div`
  .l { font-size:9px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em; }
  .v {
    font-family:${c.mono}; font-size:13px; font-weight:700; margin-top:1px;
    color:${({ $highlight }) => $highlight ? c.acc : c.txt};
  }
  .sub { font-size:10px; color:${c.txt3}; margin-top:1px; }
`
export const BDriver = styled.div`
  padding:8px 16px;
  border-top:1px solid ${c.bdr};
  font-size:11px; color:${c.txt2};
  display:flex; align-items:center; gap:6px;
  .lbl { font-size:9px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em; }
  .name { font-weight:500; color:${c.txt}; }
  &.empty { color:${c.txt3}; font-style:italic; }
`
export const BActions = styled.div`
  display:flex; gap:5px; padding:8px 12px;
  border-top:1px solid ${c.bdr}; background:${c.bg3};
  justify-content:flex-end;
`
export const IconBtn = styled.button`
  background:transparent; border:1px solid ${c.bdr2}; border-radius:6px;
  width:30px; height:30px; cursor:pointer; transition:.12s;
  font-size:13px; color:${c.txt3}; padding:0;
  display:inline-flex; align-items:center; justify-content:center;
  &:hover {
    border-color:${({ $danger }) => $danger ? c.danger : c.warn};
    color:${({ $danger }) => $danger ? c.danger : c.warn};
    background:${({ $danger }) => $danger ? 'rgba(239,68,68,.08)' : 'rgba(245,158,11,.08)'};
  }
  &:disabled { opacity:.4; cursor:not-allowed; pointer-events:none; }
`

export const Empty = styled.div`
  grid-column: 1 / -1;
  text-align:center; padding:50px 20px; color:${c.txt3}; font-size:13px;
  background:${c.bg2}; border:1px dashed ${c.bdr2}; border-radius:10px;
  strong { color:${c.acc}; }
`
export const Loading = styled.div`
  grid-column: 1 / -1;
  text-align:center; padding:40px 20px; color:${c.txt3}; font-size:12px;
`

// ─── Modal Form ─────────────────────────────────────────────────────────────
export const ModalOverlay = styled.div`
  position:fixed; inset:0; z-index:2000;
  background:rgba(0,0,0,.6); backdrop-filter:blur(2px);
  display:${({ $visible }) => $visible ? 'flex' : 'none'};
  align-items:center; justify-content:center;
`
export const ModalBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; width:440px; max-width:calc(100vw - 40px);
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  h3 { font-size:15px; font-weight:600; color:${c.txt}; margin-bottom:6px; }
  p { font-size:12px; color:${c.txt3}; margin-bottom:14px; line-height:1.5; }
`
export const Label = styled.div`
  font-size:10px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
  margin:14px 0 6px;
  .opt { text-transform:none; opacity:.6; margin-left:5px; }
`
export const Input = styled.input`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:10px 12px; font-size:13px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const Select = styled.select`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:10px 12px; font-size:13px; font-family:${c.sans}; outline:none;
  cursor:pointer; appearance:none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8' fill='none' stroke='%238a95a3' stroke-width='1.5'%3E%3Cpath d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 12px center; background-size:12px;
  padding-right:32px;
  &:focus { border-color:${c.acc}; }
  option { background:${c.bg3}; color:${c.txt}; }
`
export const StatusToggle = styled.div`
  display:flex; align-items:center; gap:10px;
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  padding:10px 12px;
  .lbl { flex:1; font-size:12px; color:${c.txt}; }
  .hint { font-size:10px; color:${c.txt3}; margin-top:2px; display:block; }
`
export const Switch = styled.button`
  position:relative; width:42px; height:22px; border:none; border-radius:11px;
  background:${({ $on }) => $on ? c.acc : c.bdr2};
  cursor:pointer; transition:.18s; flex-shrink:0;
  &::after {
    content:''; position:absolute; top:2px; left:${({ $on }) => $on ? '22px' : '2px'};
    width:18px; height:18px; border-radius:50%;
    background:#fff; transition:.18s;
  }
`
export const SeqHint = styled.div`
  margin-top:8px; padding:8px 12px;
  background:${c.bg3}; border:1px dashed ${c.bdr2}; border-radius:7px;
  font-size:10px; color:${c.txt3}; line-height:1.5;
  strong { color:${c.txt}; }
`
export const ModalActions = styled.div`
  display:flex; justify-content:flex-end; gap:8px; margin-top:20px;
`
export const ModalBtn = styled.button`
  padding:8px 18px; border-radius:7px; cursor:pointer;
  font-size:12px; font-weight:600; transition:.15s; font-family:${c.sans};
  background:${({ $primary }) => $primary ? c.acc : 'transparent'};
  border:1px solid ${({ $primary }) => $primary ? c.acc : c.bdr2};
  color:${({ $primary }) => $primary ? '#000' : c.txt2};
  &:hover { ${({ $primary }) => $primary ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`} }
  &:disabled { opacity:.5; cursor:not-allowed; }
`

// ─── Confirm ───────────────────────────────────────────────────────────────
export const ConfirmBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; min-width:340px; max-width:440px;
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  border-top:3px solid ${({ $tone }) => $tone === 'danger' ? c.danger : c.warn};
`
export const ConfirmIcon = styled.div`
  width:42px; height:42px; border-radius:50%;
  background:${({ $tone }) => $tone === 'danger' ? 'rgba(239,68,68,.15)' : 'rgba(245,158,11,.15)'};
  color:${({ $tone }) => $tone === 'danger' ? c.danger : c.warn};
  display:flex; align-items:center; justify-content:center;
  font-size:22px; margin-bottom:12px;
`
export const ConfirmTitle = styled.h3`
  font-size:15px; font-weight:600; color:${c.txt}; margin-bottom:6px;
`
export const ConfirmMessage = styled.p`
  font-size:12px; color:${c.txt2}; line-height:1.6; margin-bottom:18px;
  white-space:pre-line;
`
export const ConfirmBtn = styled.button`
  padding:8px 18px; border-radius:7px; cursor:pointer;
  font-size:12px; font-weight:600; transition:.15s; font-family:${c.sans};
  background:${({ $primary, $tone }) =>
    $primary ? ($tone === 'danger' ? c.danger : c.warn) : 'transparent'};
  border:1px solid ${({ $primary, $tone }) =>
    $primary ? ($tone === 'danger' ? c.danger : c.warn) : c.bdr2};
  color:${({ $primary }) => $primary ? '#fff' : c.txt2};
  &:hover { ${({ $primary }) => $primary ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`} }
`
